import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { login_url } from "../../constants";
import { message } from 'antd';


export const signinSlice = createSlice({
  name: "signIn",
  initialState: {
    fetchSigninResult: null,
    fetchSigninError: null,
    isFetchingSignin: false,
    redirectToDashboard: false
  },
  reducers: {
    setredirectToDashboard: (state, action) => {
      state.redirectToDashboard = false;
    },
    setSigninResult: (state, action) => {
      state.fetchSigninResult = action.payload;
      state.isFetchingSignin = false;
      state.redirectToDashboard = true;
    },
    setSigninError: (state, action) => {
      state.fetchSigninError = action.payload;
      state.isFetchingSignin = false;
    },
    setFetchingSignin: (state, action) => {
      state.isFetchingSignin = action.payload;
    },
  },
});

export const {
  setSigninResult,
  setSigninError,
  setredirectToDashboard,
  setFetchingSignin,
} = signinSlice.actions;

export const fetchSignin = (data) => (dispatch, getState) => {
  const config = {
    method: "post",
    url: login_url,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  dispatch(setFetchingSignin(true));
  const response = axios(config)
    .then((response) => {
      console.log(response);
      message.success(response.data.message)
      localStorage.setItem("token", response.data.token);
      dispatch(setSigninResult(response.data));
    })
    .catch((error) => {
      message.error(error.response.data.message)
      dispatch(setSigninError(response.message));

    });

  return response.data;
};

export default signinSlice.reducer;